import Image from 'next/image';

type ImageContainerProps = {
    className?: string;
    src?: string;
    alt?: string;
    width?: number;
    height?: number;
    useNext?: boolean;
};

export const ImageComponent = ({ className, src, alt = '', width, height, useNext = false }: ImageContainerProps) => {
    if (!src) {
        return null;
    }

    return useNext ? (
        <Image className={className} src={src} alt={alt} width={width} height={height} />
    ) : (
        <img className={className} src={src} alt={alt} width={width || 'auto'} height={height || 'auto'} />
    );
};
